<template>
    <element-loader
        is-full-page
        color="#4F71C3"
        :loading="loading"
        :z-index="9999"
        v-show="loading"
    />
</template>

<script>
export default {
    name: 'PageLoader',
    props: {
        loading: {
            type: Boolean,
        },
    },
    watch: {
        loading: {
            immediate: true,
            handler() {
                document.body.classList.toggle('overflow-hidden', this.loading);
                if (!this.loading) {
                    [...document.getElementsByClassName("vld-overlay")].forEach(elem => {
                        elem.classList.remove('fade-enter');
                        elem.classList.remove('fade-enter-active');
                        elem.style.display = 'none';
                    })
                }
            },
        },
    },
}
</script>
